var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 253,
    viewBox: "0 0 256 253",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 76.5445L249.2 0.683492C252.16 -1.16808 256 0.959452 256 4.45786V252.8L206.756 234.311C197.876 230.982 192 222.48 192 212.991V132.635L128 172.693L64 132.635V212.991C64 222.48 58.1156 230.982 49.2444 234.311L0 252.8V4.45786C0 0.959452 3.83999 -1.16808 6.79999 0.683492L128 76.5445Z",
    fill: "#1E294C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 174.607V252.8L206.756 234.311C197.876 230.982 192 222.481 192 212.991V212.751L256 172.693V174.607Z",
    fill: "#4BC07F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 92.5679V172.684L192 132.626L256 92.5679Z",
    fill: "#0B61A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 212.742V132.626L256 172.684L192 212.742Z",
    fill: "#3B9BA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 92.5679V172.684L64 132.626L0 92.5679Z",
    fill: "#0B61A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 212.742V132.626L0 172.684L64 212.742Z",
    fill: "#3B9BA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 174.607V252.8L49.2444 234.311C58.1244 230.982 64 222.481 64 212.991V212.751L0 172.693V174.607Z",
    fill: "#4BC07F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M0 92.5679L64 148.703V132.626L0 92.5679Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M256 92.5679L192 148.703V132.626L256 92.5679Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 252.8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f153e9716017ef1210dba7a46fa25089.svg";
export { ForwardRef as ReactComponent };